
define('text!presentation/common/actionModal/views/confirmAction.html',[],function () { return '<span class="action-modal__action-text" data-bind="text: confirmActionText"/>';});

